import type { AssetPositionGroup } from "kubb";
import React from "react";
import { SchemeContext } from "../../reducers/scheme";
import {
  SelectComboField,
  type SelectComboFieldProps,
} from "../Forms/SelectCombo/SelectCombo";
import { assetPositionGroupListToOptions } from "./model";

type AssetPositionGroupSelectProps = Omit<
  SelectComboFieldProps,
  "options" | "placeholder"
>;

export default function AssetPositionGroupSelect(
  props: AssetPositionGroupSelectProps,
): React.ReactElement {
  const assetPositionGroups = React.useContext(SchemeContext).state.groups;

  const ready = !assetPositionGroups.loading && !assetPositionGroups.error;
  const haveGroups =
    assetPositionGroups.groups && assetPositionGroups.groups.length > 0;
  const altText: string = ready
    ? haveGroups
      ? "All"
      : "No Groups"
    : assetPositionGroups.loading
      ? "Loading Groups"
      : assetPositionGroups.error?.message || "Error Loading Groups";
  return (
    <SelectComboField
      {...props}
      options={
        haveGroups
          ? assetPositionGroupListToOptions(
              assetPositionGroups.groups as AssetPositionGroup[],
              0,
            )
          : []
      }
      disabled={props.disabled || (ready && !haveGroups) || !ready}
      placeholder={altText}
    />
  );
}
